export const siteConfig = {
  name: '每日吃瓜',
  tagline: '娱乐圈最新内幕热榜，吃瓜日报每日更新',
  slogan: '不生产瓜，只做最全的吃瓜日报',
  description: '每日吃瓜是国内领先的娱乐八卦聚合平台，专注每日吃瓜爆料与每日吃瓜每日爆料两大核心栏目。我们实时追踪今日吃瓜动态，覆盖明星八卦、娱乐圈最新内幕、影视综爆料等全方位瓜料，打造吃瓜日报式的沉浸阅读体验。无论是最新恋情曝光、剧组路透、综艺名场面还是行业深扒，这里都有你想不到的精彩。每天更新数百条独家及精选瓜料，让你不错过任何一个精彩瞬间。',
  stats: [
    { label: '每日更新', value: '全天候追踪' },
    { label: '覆盖范围', value: '全明星矩阵' },
    { label: '内容特点', value: '独家+精选聚合' },
  ],
};

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '最新快讯', href: '#updates' },
  { label: '爆料热榜', href: '#ranking' },
  { label: '瓜友热评', href: '#comments' },
  { label: '吃瓜指南', href: '#faq' },
];

export const aboutData = {
  title: '关于每日吃瓜',
  subtitle: '你的随身娱乐圈内幕雷达',
  description: '每日吃瓜诞生于全民吃瓜时代，致力于打造中文互联网最全面的娱乐八卦聚合平台。我们从全网数百个信源精选每日吃瓜爆料与每日吃瓜每日爆料内容，涵盖今日吃瓜焦点、明星八卦深扒、娱乐圈最新内幕解读、吃瓜日报连载及爆猛料热榜排行。平台始终坚持"真实有趣、快速全面"的运营理念，让每一位吃瓜群众都能在这里找到最对味的瓜料。',
  highlights: [
    '全网信源聚合，覆盖微博、豆瓣、知乎等主流吃瓜阵地',
    '编辑团队 7×24 小时实时追踪，热点瓜料闪电上线',
    '吃瓜日报每日精选，深度解读娱乐圈风云变幻',
  ],
};

export const contactData = {
  title: '投稿爆料',
  subtitle: '有猛料？我们在这里等你',
  description: '如果你掌握了独家明星八卦、娱乐圈最新内幕或任何值得分享的今日吃瓜猛料，欢迎通过以下方式联系我们。每日吃瓜团队承诺严格保护爆料人隐私，让每一个值得被看见的真相都能安全抵达吃瓜群众手中。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@mrichigua.com' },
    { icon: 'ri-wechat-line', label: '微信爆料', value: 'mrichigua_tips' },
    { icon: 'ri-chat-smile-2-line', label: '在线留言', value: '下方直接留言即可' },
  ],
};

export const mediaData = [
  {
    title: '顶流剧组深夜路透曝光，主角造型引发全网热议',
    tag: '路透曝光',
    description: '某S+级古装剧组最新路透流出，主角造型与之前官方海报相差巨大，网友直呼"这造型是认真的吗？"',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20night%20scene%20with%20costumed%20actors%20walking%20illuminated%20by%20studio%20lights%2C%20cinematic%20mood%2C%20warm%20amber%20and%20crimson%20lighting%2C%20editorial%20entertainment%20photography%20style%2C%20atmospheric%20backlot%20scene&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '知名综艺录制现场突发状况，导演紧急叫停',
    tag: '综艺现场',
    description: '某热门综艺最新一期录制过程中，一位嘉宾情绪失控当场离席，导演组紧急调整流程，现场观众直拍视频疯传。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20recording%20studio%20with%20colorful%20stage%20lighting%20and%20audience%20seating%2C%20dramatic%20atmosphere%20with%20stage%20spotlights%2C%20entertainment%20production%20scene%2C%20warm%20vibrant%20colors%2C%20behind%20the%20scenes%20television%20production&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '双顶流恋情实锤？同款酒店行程完全重合',
    tag: '恋情实锤',
    description: '有网友发现两位顶流艺人近三个月的行程高度重合，同款酒店、同款餐厅、同航班记录全被扒出，两人工作室至今沉默。',
    image: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20lobby%20at%20night%20with%20elegant%20chandeliers%20and%20marble%20floors%2C%20paparazzi%20style%20photography%2C%20warm%20golden%20interior%20lighting%2C%20mysterious%20celebrity%20atmosphere%2C%20editorial%20entertainment%20news%20style&width=800&height=500&seq=media-03&orientation=landscape',
  },
];

export const rankingData = [
  { rank: 1, title: '某85花深夜发文暗示婚变，三小时内删除引猜测', hot: '980万', tag: '爆' },
  { rank: 2, title: '选秀出身男团成员被拍到与女网红同游日本', hot: '876万', tag: '热' },
  { rank: 3, title: '三年未同框的荧幕情侣疑似复合，同款手链被扒', hot: '765万', tag: '热' },
  { rank: 4, title: '某导演新片选角名单流出，争议艺人赫然在列', hot: '654万', tag: '新' },
  { rank: 5, title: '综艺录制现场两位导师因选手去留问题当场互呛', hot: '543万', tag: '热' },
  { rank: 6, title: '某女星工作室凌晨发律师函，否认偷税漏税传闻', hot: '432万', tag: '新' },
];

export const commentsData = [
  {
    author: '吃瓜第一线',
    content: '这个瓜我吃了三天了，每天都有新进展，真的太刺激了。不过感觉男方那边已经在准备公关了，看看后续怎么说吧。',
    time: '2小时前',
    likes: '2.3万',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20person%20avatar%20profile%20photo%2C%20stylish%20casual%20look%2C%20warm%20lighting%2C%20clean%20background%2C%20modern%20social%20media%20profile%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    author: '娱乐观察员小王',
    content: '作为一个追星十年的老人家，这种级别的爆料已经很多年没见过了。现在的娱乐圈真的越来越敢了，期待后续！',
    time: '5小时前',
    likes: '1.8万',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20avatar%20profile%20portrait%2C%20trendy%20fashion%20style%2C%20soft%20natural%20lighting%2C%20minimal%20background%2C%20social%20media%20profile%20picture&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    author: '资深八卦研究员',
    content: '理性分析一波，这次的事情没有那么简单。结合之前几个线索来看，背后可能有更大的运作。建议大家先别站队，等子弹飞一会儿。',
    time: '8小时前',
    likes: '3.1万',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20person%20avatar%20portrait%2C%20intellectual%20look%20with%20glasses%2C%20warm%20studio%20lighting%2C%20simple%20background%2C%20professional%20profile%20photo&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export const updatesData = [
  { time: '10分钟前', title: '某男团成员机场被围堵，粉丝秩序混乱引发安全担忧', tag: '突发' },
  { time: '28分钟前', title: '知名制片人朋友圈截图流出，暗指某剧主演耍大牌', tag: '独家' },
  { time: '1小时前', title: '某女歌手新歌疑似暗讽前男友，歌词细节被逐句解读', tag: '热议' },
  { time: '2小时前', title: '跨年晚会首批阵容公布，多位顶流确认出席引期待', tag: '官宣' },
  { time: '3小时前', title: '某综艺录制现场观众爆料：录制中断超两小时', tag: '现场' },
  { time: '5小时前', title: '某知名导演接受专访称"现在的流量明星没有演技"', tag: '争议' },
  { time: '7小时前', title: '年度最受期待古装剧定档，官微评论区已被攻陷', tag: '定档' },
  { time: '9小时前', title: '某顶流工作室发布声明：将追究恶意造谣者法律责任', tag: '声明' },
];

export const indexData = [
  {
    title: '2024年度十大娱乐圈名场面盘点',
    description: '回顾这一年来最令人印象深刻的娱乐圈高光与争议时刻',
    count: '12篇精选',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20award%20show%20red%20carpet%20with%20celebrities%20posing%2C%20glamorous%20event%20photography%2C%20warm%20spotlights%20and%20golden%20decorations%2C%20editorial%20photo%20collage%20style&width=600&height=400&seq=index-01&orientation=landscape',
  },
  {
    title: '选秀十年：从超级女声到创造营，偶像产业变迁',
    description: '深度复盘中国选秀综艺从巅峰到转型的完整历程',
    count: '8篇深度',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20stage%20with%20young%20performers%20under%20colorful%20stage%20lights%2C%20audience%20cheering%2C%20competition%20atmosphere%2C%20entertainment%20show%20production%2C%20vibrant%20energy&width=600&height=400&seq=index-02&orientation=landscape',
  },
  {
    title: '古装剧服化道大比拼：谁才是真正的东方美学代言人',
    description: '从服化道到场景设计，盘点近年古装剧的审美进化',
    count: '15篇对比',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20elegant%20traditional%20hanfu%20clothing%20display%2C%20intricate%20embroidery%20details%2C%20warm%20golden%20lighting%2C%20artistic%20presentation%2C%20cultural%20aesthetic%20photography&width=600&height=400&seq=index-03&orientation=landscape',
  },
  {
    title: '娱乐圈商业版图：明星副业大盘点，谁是跨界之王',
    description: '从火锅店到潮牌，明星们的商业帝国到底有多庞大',
    count: '10篇分析',
    image: 'https://readdy.ai/api/search-image?query=modern%20fashion%20brand%20store%20interior%20with%20trendy%20clothing%20display%2C%20warm%20ambient%20lighting%2C%20luxury%20retail%20atmosphere%2C%20clean%20minimalist%20design%2C%20commercial%20photography&width=600&height=400&seq=index-04&orientation=landscape',
  },
  {
    title: '那些年我们追过的CP：荧幕情侣真实关系大揭秘',
    description: '从戏里甜到戏外？盘点那些让人意难平的荧幕情侣',
    count: '20篇合集',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20drama%20scene%20with%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20warm%20sunset%20lighting%2C%20cinematic%20mood%2C%20emotional%20storytelling%20photography&width=600&height=400&seq=index-05&orientation=landscape',
  },
  {
    title: '综艺名场面年鉴：那些笑到头掉和哭到崩溃的瞬间',
    description: '综艺史上最令人难忘的高能片段全收录',
    count: '18篇回顾',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20funny%20moment%20with%20celebrities%20laughing%20on%20colorful%20stage%2C%20bright%20studio%20lighting%2C%20joyful%20entertainment%20atmosphere%2C%20dynamic%20action%20shot&width=600&height=400&seq=index-06&orientation=landscape',
  },
  {
    title: '新人突围战：2024年最值得关注的十位新生代艺人',
    description: '谁是下一个顶流？深度分析今年势头最猛的新人发展路径',
    count: '10篇特写',
    image: 'https://readdy.ai/api/search-image?query=young%20Chinese%20actor%20portrait%20in%20studio%20with%20dramatic%20lighting%2C%20fashion%20editorial%20style%2C%20modern%20clean%20aesthetic%2C%20emerging%20star%20photography%2C%20warm%20and%20cool%20tone%20contrast&width=600&height=400&seq=index-07&orientation=landscape',
  },
  {
    title: '音乐圈风云录：年度十大神曲背后的创作故事',
    description: '那些洗脑全网的热门单曲是如何诞生的',
    count: '10篇揭秘',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20recording%20studio%20with%20professional%20equipment%20and%20warm%20ambient%20lighting%2C%20creative%20atmosphere%2C%20modern%20production%20environment%2C%20artistic%20interior&width=600&height=400&seq=index-08&orientation=landscape',
  },
];

export const appData = {
  title: '吃瓜小程序',
  subtitle: '随时随地，瓜不落地',
  description: '每日吃瓜小程序已全面上线，微信搜索即可直达。支持推送订阅、离线阅读、夜间模式，让你不错过任何一个热点瓜料。地铁上、排队时、睡前——随时随地打开吃瓜，精彩内容即时触达。',
  features: [
    '实时推送：重大爆料一秒到达',
    '专题聚合：同类瓜料智能归类',
    '瓜友社区：和千万吃瓜群众一起讨论',
    '夜间模式：深夜吃瓜不伤眼',
  ],
  image: 'https://readdy.ai/api/search-image?query=Chinese%20mobile%20app%20interface%20mockup%20on%20phone%20screen%2C%20entertainment%20news%20feed%20design%2C%20warm%20red%20and%20white%20color%20scheme%2C%20modern%20UI%20design%2C%20clean%20minimal%20layout%2C%20social%20media%20style&width=400&height=700&seq=app-mockup&orientation=portrait',
};

export const carouselData = [
  {
    title: '深扒某顶流商业帝国：从代言到投资的全版图',
    tag: '深度专题',
    description: '这位顶流艺人不仅在娱乐圈呼风唤雨，其商业布局更是令人叹为观止。从潮牌到餐饮，从影视投资到科技创投，一个庞大的商业帝国正浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20office%20with%20floor%20to%20ceiling%20windows%20and%20city%20skyline%20view%2C%20business%20empire%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20power%20and%20success%20theme%2C%20editorial%20photography&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '某85花离婚内幕全解析：财产分割与抚养权之争',
    tag: '独家深扒',
    description: '当红85花离婚案持续发酵，从最初的和平分手声明到如今的财产争夺，这场持续数月的离婚大戏背后到底隐藏了多少不为人知的细节？',
    image: 'https://readdy.ai/api/search-image?query=elegant%20mansion%20interior%20with%20dramatic%20curtains%20and%20chandelier%2C%20mysterious%20atmosphere%2C%20warm%20dim%20lighting%2C%20luxury%20divorce%20drama%20theme%2C%20cinematic%20photography%20style&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '综艺节目幕后：那些被剪辑删掉的真实画面',
    tag: '幕后揭秘',
    description: '综艺节目到底有多少内容被剪掉了？从选手淘汰真相到嘉宾私下互动，我们整理了近期大热综艺中被"消失"的精彩瞬间。',
    image: 'https://readdy.ai/api/search-image?query=television%20editing%20room%20with%20multiple%20monitors%20displaying%20variety%20show%20footage%2C%20professional%20video%20production%20environment%2C%20warm%20screen%20glow%2C%20behind%20the%20scenes%20post%20production&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '选秀艺人转型之路：有人逆袭有人落魄',
    tag: '行业观察',
    description: '选秀出道后，这些艺人的发展轨迹天差地别。有人成功转型演员收获口碑，有人沦为综艺咖被市场遗忘。我们追踪了近百位选秀艺人的职业发展。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20stage%20spotlight%20with%20single%20performer%20silhouette%2C%20contrasting%20light%20and%20shadow%2C%20emotional%20performance%20moment%2C%20theatrical%20atmosphere%2C%20career%20transformation%20theme&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '娱乐圈潜规则大起底：从业者匿名讲述真实生态',
    tag: '行业真相',
    description: '多位匿名娱乐圈从业者首次开口，讲述这个光鲜行业背后不为人知的规则。从选角内定到番位之争，从资源置换到人脉运作——真相远比你想的复杂。',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20shadowy%20figure%20behind%20frosted%20glass%20in%20modern%20office%2C%20anonymous%20interview%20setting%2C%20dramatic%20contrast%20lighting%2C%20secrecy%20and%20revelation%20theme%2C%20cinematic%20noir%20style&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const topicsData = [
  { name: '某顶流恋情', count: '1280万讨论' },
  { name: '选秀节目黑幕', count: '965万讨论' },
  { name: '85花婚变', count: '892万讨论' },
  { name: '综艺名场面', count: '756万讨论' },
  { name: '新剧路透', count: '689万讨论' },
  { name: '艺人税务', count: '567万讨论' },
  { name: '跨年晚会阵容', count: '498万讨论' },
  { name: '古装剧服化道', count: '432万讨论' },
  { name: '明星副业', count: '378万讨论' },
  { name: 'CP营业', count: '321万讨论' },
];

export const faqData = [
  {
    question: '每日吃瓜的内容来源是什么？如何保证信息真实可靠？',
    answer: '每日吃瓜的内容来源于全网公开信息聚合与编辑团队日常追踪，涵盖微博、豆瓣、知乎、小红书等主流平台。我们的编辑团队会对每一条爆料进行交叉验证，标注信息来源与可信度等级。对于未经证实的传闻，我们会明确标注"待核实"，绝不混淆视听。同时，我们建立了完善的内容纠错机制，如发现信息有误，会在第一时间更正并公开说明。',
  },
  {
    question: '如何向每日吃瓜投稿爆料？爆料人信息安全如何保障？',
    answer: '你可以通过投稿邮箱 tips@mrichigua.com 或微信公众号"每日吃瓜"向我们爆料。收到爆料后，编辑团队会进行独立核实，确认信息后才会发布。我们承诺严格保护每一位爆料人的隐私：所有投稿信息采用加密存储，编辑团队签署保密协议，绝不向任何第三方透露爆料人身份信息。如果你希望完全匿名，可使用一次性邮箱发送，我们同样认真对待。',
  },
  {
    question: '每日吃瓜的更新频率是怎样的？如何不错过重要爆料？',
    answer: '每日吃瓜实行全天候更新机制，编辑团队 7×24 小时轮值追踪。重大爆料通常会在事件发生后 30 分钟内上线，日常精选内容每小时至少更新一次。吃瓜日报专栏每日早晨 8 点准时推送前一日精华汇总。想要第一时间获取最新瓜料，建议关注我们的微信公众号并开启推送通知，或收藏网站首页随时刷新。',
  },
  {
    question: '每日吃瓜和其他娱乐八卦平台有什么不同？',
    answer: '与其他平台相比，每日吃瓜有三大核心差异：第一，我们不生产瓜，只做全网最全的吃瓜聚合器，信息来源更广、更新更快；第二，我们坚持"有据可查"的内容原则，每条爆料都会标注来源和可信度，让吃瓜群众自行判断；第三，我们打造了独特的"吃瓜日报"式阅读体验，将碎片化的八卦信息整理成有逻辑、有深度的内容，让你吃得明白、吃得过瘾。',
  },
  {
    question: '遇到不实信息或侵权内容如何申诉？处理流程是怎样的？',
    answer: '如发现每日吃瓜平台上的内容存在事实错误或侵犯了您的合法权益，请发送邮件至 tips@mrichigua.com 进行申诉，邮件标题请注明"内容申诉"或"侵权投诉"。我们承诺在收到申诉后 2 小时内启动核查流程，24 小时内给出处理结果。对于确认存在问题的内容，我们会立即修正或下架，并在原位置发布更正声明。对于恶意投诉，我们保留追究法律责任的权利。',
  },
];

export const cardsData = [
  {
    title: '某流量小生深夜密会神秘女子，疑似新恋情曝光',
    tag: '独家爆料',
    date: '2024年7月30日',
    description: '记者独家拍到某当红流量小生与一位神秘女子在某高档餐厅共进晚餐，两人举止亲密，用餐后同乘一辆车离开。据知情人士透露，两人已交往数月，但双方团队均未回应。',
    image: 'https://readdy.ai/api/search-image?query=upscale%20restaurant%20private%20dining%20room%20with%20candlelight%20and%20wine%20glasses%2C%20intimate%20romantic%20atmosphere%2C%20warm%20amber%20lighting%2C%20celebrity%20dating%20scene%2C%20paparazzi%20style%20photography&width=700&height=450&seq=card-01&orientation=landscape',
  },
  {
    title: '某综艺导师因不当言论引发争议，节目组紧急公关',
    tag: '争议事件',
    date: '2024年7月29日',
    description: '某音乐选秀综艺最新一期中，一位导师对选手的评价被指带有歧视性含义，引发网友强烈不满。节目组连夜发布道歉声明，但该导师本人至今未作出任何回应，事件仍在持续发酵。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20judging%20panel%20with%20red%20chairs%20and%20dramatic%20stage%20lighting%2C%20tense%20atmosphere%2C%20controversy%20moment%2C%20television%20production%2C%20editorial%20style&width=700&height=450&seq=card-02&orientation=landscape',
  },
  {
    title: '年度最受期待电影阵容公布，多位影帝影后加盟',
    tag: '影视动态',
    date: '2024年7月28日',
    description: '某知名导演筹备三年的巨制今日正式公布演员阵容，集结了三位影帝两位影后的豪华班底。据悉该片投资高达5亿，预计明年春节档上映，业内普遍看好其票房表现。',
    image: 'https://readdy.ai/api/search-image?query=grand%20movie%20press%20conference%20with%20film%20posters%20and%20spotlights%2C%20celebrities%20on%20stage%2C%20cinematic%20atmosphere%2C%20golden%20and%20crimson%20color%20scheme%2C%20film%20industry%20event&width=700&height=450&seq=card-03&orientation=landscape',
  },
  {
    title: '某女星工作室凌晨五点发声明，否认所有不实传闻',
    tag: '官方声明',
    date: '2024年7月27日',
    description: '近日网络上出现大量针对某一线女星的不实言论，其工作室于今日凌晨五点发布严正声明，表示已委托律师取证并保留追究法律责任的权利。网友对此反应两极分化。',
    image: 'https://readdy.ai/api/search-image?query=official%20press%20release%20document%20on%20desk%20with%20lawyer%20stamp%20and%20formal%20letterhead%2C%20legal%20atmosphere%2C%20professional%20office%20setting%2C%20warm%20desk%20lamp%20lighting%2C%20statement%20announcement&width=700&height=450&seq=card-04&orientation=landscape',
  },
  {
    title: '某组合解散后成员各自发展，有人翻红有人被遗忘',
    tag: '行业观察',
    date: '2024年7月26日',
    description: '曾经红极一时的某偶像团体解散已有两年。我们追踪了各成员解散后的发展轨迹：有人在综艺中重获关注，有人转型幕后，也有人彻底淡出公众视野。命运天差地别，令人唏嘘。',
    image: 'https://readdy.ai/api/search-image?query=empty%20concert%20stage%20with%20lingering%20spotlights%20and%20confetti%20on%20floor%2C%20bittersweet%20atmosphere%2C%20end%20of%20an%20era%20feeling%2C%20music%20group%20disbandment%20theme%2C%20emotional%20cinematic%20photography&width=700&height=450&seq=card-05&orientation=landscape',
  },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '闪电追踪',
    description: '7×24小时全天候监测全网瓜源，重大爆料从发生到上线平均不超过30分钟，让你永远快人一步吃到最新鲜的瓜。覆盖微博、豆瓣、知乎等主流吃瓜阵地，全网瓜料一网打尽。',
  },
  {
    icon: 'ri-stack-line',
    title: '吃瓜日报',
    description: '每日精选当日最热门、最劲爆的瓜料，编辑团队深度整理编排，打造像追连载小说一样的沉浸式吃瓜体验。每天早晨8点准时推送，帮你回顾昨日精彩，开启今日吃瓜之旅。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '可信度分级',
    description: '每条爆料均标注信息来源与可信度等级——从"多方证实"到"待核实"再到"纯属八卦"，让你对每条瓜的可信程度一目了然。我们坚持不造谣、不传谣、及时更正的编辑原则。',
  },
  {
    icon: 'ri-group-line',
    title: '瓜友社区',
    description: '千万吃瓜群众聚集地，每条爆料下方都有精彩的瓜友评论和深度分析。在这里你不仅能吃到瓜，还能看到各路大神的神级解读和脑洞大开的推理，让吃瓜这件事变得更有趣。',
  },
];